module.exports = __webpack_public_path__ + "img/hic-endocrine-nutritional-metabolic-diseases-female.17a70760.png";